module.exports = __webpack_public_path__ + "static/media/locationContact.5b88b339.svg";